<template>
  <div  class="s-contract" :style="{...defaultBg.style, backgroundImage: `url(${defaultBg.src})`}">
    <div class="s-contract-list" :style="{...boxStyleObj, ...getSize(boxSize), top: boxPosition[0].top, left: boxPosition[0].left}">
      <div class="s-contract-item" v-for="(item, index) in missionList" :key="index" :style="{...itemStyleObj, ...getSize(itemSize)}">
        <img v-if="item.icon" :src="item.icon" :style="{...getSize(imgStyle)}" alt="">
        <img v-if="getBtnImg(item.status)" @click="receiveFun(item)" :src="getBtnImg(item.status)" :style="{...getSize(btnStyle)}" alt="">
        <div v-else></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSize, getPosition } from '@/components/BuilderComponents/utils'
export default {
  name: 'SVersionContract',
  components: {},
  props: {
    activityId: {
      type: String,
      default: ''
    },
    defaultBg: {
      type: Object,
      required: true
    },
    request: {
      type: Function
    },
    boxStyle: {
      type: String,
      default: '{}'
    },
    boxSize: {
      type: String,
      default: '1220px 520px'
    },
    boxPosition: {
      type: Array,
      required: true,
      default: () => [
        { top: '0', left: '0' }
      ]
    },
    itemStyle: {
      type: String,
      default: '{}'
    },
    itemSize: {
      type: String,
      default: '393px 520px'
    },
    contractOne: {
      type: String,
      default: ''
    },
    btnList: {
      type: Array,
      default: () => []
    },
    btnStyle: {
      type: String,
      default: '200px 50px'
    },
    imgStyle: {
      type: String,
      default: '393px 437px'
    }
  },
  inject: {
    eventBus: {
      default: null
    },
    $MainWrap: {
      default: null
    }
  },
  computed: {
    requestAPI () {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    },
    boxStyleObj () {
      try {
        console.log(this.boxStyle, 'this.boxStyle')
        return JSON.parse(this.boxStyle)
      } catch (e) {
        console.error('boxStyle 格式错误', e)
        return {}
      }
    },
    itemStyleObj () {
      try {
        return JSON.parse(this.itemStyle)
      } catch (e) {
        console.error('itemStyle 格式错误', e)
        return {}
      }
    }
  },
  data () {
    return {
      getSize,
      getPosition,
      missionList: []
    }
  },
  mounted () {
    if (this.eventBus) {
      // 登录成功操作添加
      this.eventBus.on('loginSuccess', this.getMissionList)
      // 登出操作添加
      this.eventBus.on('signOut', this.reset)
    }
    this.getMissionList()
  },
  methods: {
    // 重置
    reset () {
      this.getMissionList()
    },
    // 获取活动信息
    getMissionList () {
      this.requestAPI({
        url: '/v1/uni/agreement/index',
        method: 'get',
        params: { a_id: this.activityId }
      }).then((res) => {
        if (res.list.length <= 0) {
          return
        }
        console.log(res, 'res')
        if (res.list.length === 2) {
          const item = { ...res.list[res.list.length - 1], status: -1 }
          this.missionList = [{
            id: -1,
            icon: this.contractOne,
            name: '占位',
            status: -1,
            desc: '占位'
          }, { ...res.list[0] }, { ...item }]
          console.log(this.missionList, 'this.missionList')
        } else if (res.list.length === 3) {
          // 将res.list的最后一个元素status改为-1，并重置this.missionList
          const newList = [...res.list]
          newList[newList.length - 1] = { ...newList[newList.length - 1], status: -1 }
          this.missionList = newList
        }
      }).catch((err) => {
        console.error(err, 'err')
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 点击累计立即领取
    receiveFun (item) {
      if (!window.$checkLogin()) return
      if (item.status !== 0 && item.status !== 1) {
        return
      }
      let url = "/v1/uni/agreement/sign" // 签订契约
      if (item.status === 1) {
        url = "/v1/uni/agreement/award" // 领取契约
      }
      this.requestAPI({
        url,
        method: 'get',
        params: { a_id: this.activityId, g_id: item.id }
      }).then((res) => {
        this.$MainWrap.openVersionDialogTip({
          content: item.status === 1 ? '领取成功' : '契约成功',
          btnCancelText: ''
        })
        this.getMissionList()
      }).catch((err) => {
        console.error(err, 'err')
        this.$message.error(err.msg || '系统错误')
      })
    },
    getBtnImg(status) {
      const map = {
        0: this.btnList[0].src,
        1: this.btnList[1].src,
        2: this.btnList[2].src,
        3: this.btnList[3].src
      }
      return map[status] ? map[status] : ''
    }
  }
}
</script>
<style lang="scss" scoped>
.s-contract{
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
  .s-contract-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    .s-contract-item {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
